import { internalAxios } from '../../utils/axios/internal';

export const classifiedsForArtist = async idartist => {
  const response = await internalAxios.get(`/api/wallet/classified/classifieds_for_artist/${idartist}.json`);
  return response.data;
};
